import {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'

import {modalOpen} from "../../redux/actions";

/**
 * Extending next/link to add support for onclick property.
 *
 * @property {function} onclick
 * @property {Boolean} modal bool
 * In case modal is true following two arguments must be provided
 * @property {String} title
 * @property backpage {route, params}
 */
class ModalLink extends Component {
    static propTypes = {
        url: PropTypes.string,
        title: PropTypes.string,
        backpage: PropTypes.object,
        componentClass: PropTypes.func,
        componentParams: PropTypes.object
    }
    constructor(props) {
        super(props)
        this.clickHandler = this.clickHandler.bind(this)
    }
    clickHandler(e) {
        e.preventDefault()
        e.stopPropagation()
        const {url, title, backpage, componentClass, componentParams} = this.props
        this.props.dispatch(modalOpen(backpage, componentClass, componentParams))
        window.history.pushState({}, title, url)

    }
    render() {
        return (
            <a>
                <div onClick={this.clickHandler} style={{display: 'inline'}}>
                    {this.props.children}
                </div>
            </a>

        )
    }
}


export default connect()(ModalLink)



// WEBPACK FOOTER //
// components/links/ModalLink.js